const EMPTY = { lat: '', lng: '' };

export const LAT_LNG_STORAGE_KEY = 'hotelink_user_lat_lng';

export function saveLatLngToStorage(coords) {
  try {
    if (typeof localStorage === 'undefined') return;
    const lat = coords?.lat != null ? String(coords.lat) : '';
    const lng = coords?.lng != null ? String(coords.lng) : '';
    localStorage.setItem(LAT_LNG_STORAGE_KEY, JSON.stringify({ lat, lng }));
  } catch (_) {
    /* ignore quota / private mode */
  }
}

export function getStoredLatLng() {
  if (typeof localStorage === 'undefined') return { ...EMPTY };
  try {
    const raw = localStorage.getItem(LAT_LNG_STORAGE_KEY);
    if (!raw) return { ...EMPTY };
    const p = JSON.parse(raw);
    return {
      lat: p.lat != null && String(p.lat).trim() !== '' ? String(p.lat) : '',
      lng: p.lng != null && String(p.lng).trim() !== '' ? String(p.lng) : '',
    };
  } catch (_) {
    return { ...EMPTY };
  }
}

/**
 * 获取定位并写入 localStorage（首页、订单填写页等入口处调用）
 * @param {Object} [options] 同 getCurrentLatLng
 * @returns {Promise<{ lat: string, lng: string }>}
 */
export function refreshLatLngToStorage(options) {
  return getCurrentLatLng(options).then((coords) => {
    saveLatLngToStorage(coords);
    return coords;
  });
}

/**
 * 获取当前设备经纬度（浏览器 Geolocation API）。
 * 失败、超时或用户拒绝时返回空字符串，与现有订单参数约定一致。
 * @param {Object} [options]
 * @param {number} [options.timeoutMs=10000]
 * @param {boolean} [options.enableHighAccuracy=false]
 * @returns {Promise<{ lat: string, lng: string }>}
 */
export function getCurrentLatLng(options = {}) {
  const { timeoutMs = 10000, enableHighAccuracy = false } = options;

  if (typeof navigator === 'undefined' || !navigator.geolocation?.getCurrentPosition) {
    return Promise.resolve({ ...EMPTY });
  }

  return new Promise((resolve) => {
    let settled = false;
    const done = (value) => {
      if (settled) return;
      settled = true;
      resolve(value);
    };

    const timer = setTimeout(() => done({ ...EMPTY }), timeoutMs);

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        clearTimeout(timer);
        done({
          lat: String(pos.coords.latitude),
          lng: String(pos.coords.longitude),
        });
      },
      () => {
        clearTimeout(timer);
        done({ ...EMPTY });
      },
      { enableHighAccuracy, maximumAge: 60000, timeout: timeoutMs }
    );
  });
}
